var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"cell",class:{ disabled: _vm.props.disabled },style:({ background: _vm.props.color })})}
var staticRenderFns = []

export { render, staticRenderFns }